<script setup>

import {ErrorMessage, Field, Form} from 'vee-validate'
import {reactive, ref} from 'vue'
import axios from 'axios'
import {useFormSubmit} from '../../composables/useFormSubmit'

const { showServerSideValidateErrors, enquirySubmitDataLayer, sendFBLeadData } = useFormSubmit()
const props = defineProps({
  placeHolderText: {
    type: String,
    default: '',
  },
})

const schema = {
  first_name: 'required',
  last_name: 'required',
  email: 'required|email',
  phone_number: 'required|phoneNumber',
}

const confirmation = reactive({show: false, message: '', class: ''})
let isSubmitting = ref(false)

const onSubmit = async () => {
  isSubmitting.value = true
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  const form  = document.getElementById('propertyInfoForm');
  let formData = new FormData(form);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    const submitButton = form.querySelector('.submit');
    submitButton.disabled = true;
    formData.set('g-recaptcha-response', token);
    axios.post('/enquiry-submitted', formData).then(function (response) {
      confirmation.class = 'message--success'
      confirmation.message = response.data.msg
      enquirySubmitDataLayer(form);
      sendFBLeadData(formData.get('subject'));
    }).catch(error => {
      submitButton.disabled = false;
      showServerSideValidateErrors(error, isSubmitting, confirmation)
    });
  });
}
</script>

<template>
  <Form
    :validation-schema="schema"
    v-slot="{ errors }"
    @submit="onSubmit"
    id="propertyInfoForm"
  >
    <slot name="token"></slot>

    <p class="fs-17 p-0 m-0 text-left text-sm-center font-weight-bold mb-6">
      Request more information for this retirement village property
    </p>
    <div class="form-group form-group--input">
      <label for="first_name"  class="sr-only">First name</label>
      <Field
        id="first_name"
        name="first_name"
        placeholder="First name *"
        class="form-control form-control--bg-white"
        :class="{'is-danger': errors['first_name'] }"
      />
      <ErrorMessage name="first_name" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="last_name"  class="sr-only">Last name</label>
      <Field
        name="last_name"
        placeholder="Last name *"
        class="form-control form-control--bg-white"
        :class="{'is-danger': errors['last_name'] }"
        id="last_name"
      />
      <ErrorMessage name="last_name" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="email" class="sr-only">Email</label>
      <Field
        id="email"
        name="email"
        placeholder="Email *"
        class="form-control form-control--bg-white"
        :class="{'is-danger': errors['email'] }"
      />
      <ErrorMessage name="email" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="phone_number" class="sr-only">Phone</label>
      <Field
        id="phone_number"
        name="phone_number"
        placeholder="Phone *"
        class="form-control form-control--bg-white"
        :class="{'is-danger': errors['phone_number'] }"
      />
      <ErrorMessage name="phone_number" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="message" class="sr-only">Message</label>
      <textarea
        :placeholder="placeHolderText"
        tabindex="6"
        id="message"
        rows="5"
        class="form-control form-control--textarea form-control--bg-white"
        name="message"
      ></textarea>
    </div>
    <div class="checkbox-custom mt-4 mb-2">
      <input type="checkbox" class="subscribe" id="notify" name="subscribe" value="1" checked>
      <label class="fs-14 lh1-3" for="notify">
        Please notify me of new retirement village listings and open days
      </label>
    </div>
    <input type="hidden" name="captcha_action" value="property__form">

    <transition name="fade">
      <div :class="confirmation.class" class="message" v-if="confirmation.show">{{ confirmation.message }}</div>
    </transition>
    <div class="form-group">
      <slot name="hiddenfields"></slot>
      <button tabindex="12" type="submit" class="btn btn--green pt-2 pb-2 fs-14 btn--auto-width submit">
        Enquire
      </button>
    </div>
      <slot name="googlerecaptchatext"></slot>
  </Form>
</template>
